export default class ErrorCatch {
  static reloadPage() {
    const triggerTime = +window.sessionStorage.getItem('LoadingChunk')
    if (triggerTime && new Date(triggerTime) > new Date()) {
      // Prevent infinite loop
      return
    }
    const nextTriggerTime = new Date().setMinutes(new Date().getMinutes() + 1)
    window.sessionStorage.setItem('LoadingChunk', nextTriggerTime)
    location.reload()
  }
  static lazyLoadCatch(error) {
    if (/Loading\schunk\s[\d]+\sfailed\./.test(error.message)) {
      ErrorCatch.reloadPage()
    }
  }
}
